export const COMPANY_MAX_LENGTH = 50;
export const COMPANY_MIN_LENGTH = 3;
export const DROPDOWN_HEIGHT = 7;
export const SEARCH_DEBOUNCE_INTERVAL = 500;
